/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScoringParameters } from '../../models/scoring-parameters';

export interface GetAllScoringParameters$Params {
}

export function getAllScoringParameters(http: HttpClient, rootUrl: string, params?: GetAllScoringParameters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ScoringParameters>>> {
  const rb = new RequestBuilder(rootUrl, getAllScoringParameters.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ScoringParameters>>;
    })
  );
}

getAllScoringParameters.PATH = '/api/scoringparameters/all';
